import { createStoreConfig } from "./common";
import { Shop } from "./shops";

const endpoints = {
    getItems: { method: "get", url: "/catalog_data/shops" },
};

export const useSegmentShopsDictionaryStore = createStoreConfig<Shop>(
    endpoints,
    "segment_shops_dictionarie",
    {
        order_by: "shop_name",
        in: "id__in",
        pk: "id",
        ilike: "shop_name__ilike",
        sortOptions: { primarySortField: "shop_name" },
        defaultParams: { has_data_from_providers: true },
    }
);
